import { config as deDEConfig } from './de/de';
import { config as enDEConfig } from './de/en';
import { config as enFRConfig } from './fr/en';
import { config as frFRConfig } from './fr/fr';
import { config as enGBConfig } from './gb/en';
import { config as enNLConfig } from './nl/en';
import { config as nlNlConfig } from './nl/nl';
import { config as enUSConfig } from './us/en';

export const sharedConfig = {
  'de-DE': deDEConfig,
  'en-DE': enDEConfig,
  'en-US': enUSConfig,
  'fr-FR': frFRConfig,
  'en-FR': enFRConfig,
  'nl-NL': nlNlConfig,
  'en-NL': enNLConfig,
  'en-GB': enGBConfig,
  'es-US': enUSConfig,
} as const;
